var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "FormGroup",
        {
          attrs: {
            label:
              "Bitte teile uns mit, warum der Termin nicht stattgefunden hat",
            "label-classes": ["font-weight-bold"]
          }
        },
        [
          _c("RadioGroup", {
            attrs: { options: _vm.reasonOptions, stacked: "" },
            model: {
              value: _vm.reason,
              callback: function($$v) {
                _vm.reason = $$v
              },
              expression: "reason"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.reasonValid
        ? _c(
            "FormGroup",
            {
              staticClass: "mt-3",
              attrs: {
                label: "Bitte wähle den Folgeschritt",
                "label-classes": ["font-weight-bold"]
              }
            },
            [
              _c("RadioGroup", {
                attrs: { options: _vm.followUpOptions, stacked: "" },
                model: {
                  value: _vm.followUp,
                  callback: function($$v) {
                    _vm.followUp = $$v
                  },
                  expression: "followUp"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.followUpAppointmentPossible
        ? _c("InfoBox", { staticClass: "mt-3" }, [
            _c("p", [
              _vm._v(
                _vm._s(_vm.companyName) +
                  " wird informiert, dass ein Termin möglich ist."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n\t\t\tSobald " +
                  _vm._s(_vm.companyName) +
                  " antwortet, erhältst du eine Benachrichtigung über die möglichen nächsten\n\t\t\tSchritte.\n\t\t"
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.followUpSendoff
        ? _c("ApplicantSendOff", {
            staticClass: "mt-3",
            attrs: {
              customer: _vm.message.customer,
              "is-anonymous": false,
              "with-company-name": false
            },
            model: {
              value: _vm.sendOffData,
              callback: function($$v) {
                _vm.sendOffData = $$v
              },
              expression: "sendOffData"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3 text-right" },
        [
          _c("Button", {
            attrs: {
              text: "Senden",
              icon: "checkmark",
              disabled: !_vm.dataValid || _vm.sendingRequest,
              loading: _vm.sendingRequest
            },
            on: { click: _vm.submit }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }